interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDestructive?: boolean;
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  isDestructive,
}: ConfirmDialogProps) {
  if (!open) return null;

  return (
    <div class="dialog-backdrop" onClick={onCancel}>
      <div class="dialog-card" onClick={(e) => e.stopPropagation()}>
        {isDestructive && (
          <div class="dialog-icon dialog-icon-danger">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
        )}
        <h3 class="dialog-title">{title}</h3>
        <p class="dialog-message">{message}</p>
        <div class="dialog-actions">
          <button class="btn-ghost btn-sm" onClick={onCancel}>
            Cancel
          </button>
          <button
            class={`${isDestructive ? 'btn-danger' : 'btn-primary'} btn-sm`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
